import { storage, STORAGE_KEYS } from "./storage";

const normalizeToken = (token) => {
  if (!token) return null;
  return token.startsWith("Bearer ") ? token.slice(7) : token;
};

export const tokenStorage = {
  async getAccessToken() {
    try {
      const legacyToken = storage.getItem(STORAGE_KEYS.TOKEN);
      return normalizeToken(legacyToken);
    } catch (legacyError) {
      console.error("Get access token failed", legacyError);
      return null;
    }
  },

  async getRefreshToken() {
    try {
      const legacyToken = storage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
      return normalizeToken(legacyToken);
    } catch (legacyError) {
      console.error("Get refresh token failed", legacyError);
      return null;
    }
  },

  async setTokens(accessToken, refreshToken) {
    try {
      if (accessToken) {
        storage.setItem(STORAGE_KEYS.TOKEN, accessToken);
      }

      if (refreshToken) {
        storage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
      }
    } catch (error) {
      console.error("Failed to persist tokens", error);
      throw error;
    }
  },

  async clearTokens() {
    try {
      storage.removeItem(STORAGE_KEYS.TOKEN);
      storage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    } catch (legacyError) {
      console.error("Failed to clear legacy tokens", legacyError);
    }
  },
};


